import { P } from '@hrms/shared';
import type { IconName } from '../ui/Icon';

/**
 * Bottom tabs on phones (< 1024px). Each tab root is a registry screen name; a tab only shows if
 * that screen is registered and permitted (plus the tab's own perms).
 * On wide screens the tab bar is hidden and the sidebar takes over.
 */
export const TABS: { name: string; label: string; icon: IconName; perms?: string[] }[] = [
  { name: 'Home', label: 'Home', icon: 'home' },
  { name: 'MyAttendance', label: 'Attendance', icon: 'clock' },
  { name: 'LeaveBalance', label: 'Leave', icon: 'leaf' },
  { name: 'Approvals', label: 'Approvals', icon: 'inbox', perms: [P.LEAVE_TEAM, P.ATTENDANCE_TEAM] },
];

export const MORE_TAB = 'More';
export const TAB_NAMES = new Set([...TABS.map((t) => t.name), MORE_TAB]);
